import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';
import 'payment-calculator/components/PurchaseMethodsTabControl/PurchaseMethodsTabControlHeader.scss';

const PurchaseMethodsTabControlHeader = ({
    leaseAvailable,
    leaseSelected,
    financeAvailable,
    financeSelected,
    cashPurchaseSelected,
    selectPurchaseMethod,
}) => {
    const { useEffect, useState } = React;
    const [purchaseMethodLabels, setPurchaseMethodLabels] = useState([]);
    const updatePurchaseMethodLabels = (updateCashPurchaseSelected, updateFinanceSelected, updateLeaseSelected) => {
        const arrPurchaseMethodLabels = [
            {
                name: LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.CASH_PURCHASE'),
                type: PurchaseMethods.PurchaseMethodsConstant.CASH_PURCHASE,
                selected: updateCashPurchaseSelected,
            },
        ];
        if (financeAvailable) {
            arrPurchaseMethodLabels.unshift({
                name: LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.FINANCE'),
                type: PurchaseMethods.PurchaseMethodsConstant.FINANCE,
                selected: updateFinanceSelected,
            });
        }
        if (leaseAvailable) {
            arrPurchaseMethodLabels.unshift({
                name: LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.LEASE'),
                type: PurchaseMethods.PurchaseMethodsConstant.LEASE,
                selected: updateLeaseSelected,
            });
        }
        return arrPurchaseMethodLabels;
    };
    useEffect(
        () => {
            setPurchaseMethodLabels(updatePurchaseMethodLabels(cashPurchaseSelected, financeSelected, leaseSelected));
        },
        [leaseSelected, financeSelected, cashPurchaseSelected]
    );
    return (
        <section className="purchase-methods-tab">
            <nav className="purchase-methods-tab__tabs sr-calculator-tabs">
                <ul>
                    {purchaseMethodLabels.map((method) => {
                        return (
                            <li key={method.type} className={method.selected ? 'current' : ''}>
                                <button onClick={() => selectPurchaseMethod(method.type)}>{method.name}</button>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </section>
    );
};

PurchaseMethodsTabControlHeader.propTypes = {
    leaseAvailable: PropTypes.bool.isRequired,
    leaseSelected: PropTypes.bool.isRequired,
    financeAvailable: PropTypes.bool.isRequired,
    financeSelected: PropTypes.bool.isRequired,
    cashPurchaseSelected: PropTypes.bool.isRequired,
    selectPurchaseMethod: PropTypes.func.isRequired,
};

PurchaseMethodsTabControlHeader.displayName = 'PurchaseMethodsTabControlHeader';

export default PurchaseMethodsTabControlHeader;
